import ImageWithFallback from "components/ImageWithFallback";
import Rating from "components/Rating";
import {useEffect, useState} from "react";
import Link from "next/link";
import calcOpenNow from "lib/utils/calcOpenNow";
import cn from "clsx";

export default function MapCard({data: location, className, row=false, onMouseEnter=()=>{}, t}) {
    const [openNow, setOpenNow] = useState(undefined)

    useEffect(() => {
        const {isOpen, closeTime} = calcOpenNow(location.business_hours, location.timezone)
        setOpenNow(isOpen ? `${t('home:map_openUntil')} ${closeTime}` : t('home:map_closed'))
    }, [])
    return (
        <div onMouseEnter={onMouseEnter} className={cn(row&&'flex', className)}>
            <Link href={`/stores/${location.slug}/${location.id}` } passHref>
                <div className={cn(["relative after:content-[''] after:block", row?'after:pb-[100%] w-32':'after:pb-[56.25%] mb-4'])}>
                    <ImageWithFallback
                        src={location.avatar_url}
                        alt={location.name}
                        className="object-cover transition hover:brightness-105 cursor-pointer"
                    />
                </div>
            </Link>
            <div className="px-4">
                <Link href={`/stores/${location.slug}/${location.id}`} passHref>
                    <a>
                        <h4 className="font-bold text-base mb-2">
                            {location.name}
                        </h4>
                    </a>
                </Link>
                <div className="flex flex-nowrap items-center mb-2">
                    <div className="text-xs mr-2">
                        {location.rating.toFixed(1)}
                    </div>
                    <Rating
                        value={location.rating || 5}
                        precision={0.5}
                        readOnly
                        className={'mr-2'}
                    />
                    <div className="text-xs">
                        ({location.reviews_count})
                    </div>
                </div>
                {
                    location.has_curbside_pickup &&
                    <div className="text-sm text-primary-dark font-semibold mb-1">
                        {t('home:map_pickupAvailable')}
                    </div>
                }
                <div className="text-sm mb-1">
                    {openNow}
                </div>
            </div>
        </div>
    )
}
